import { BasicClient } from '@/utils/httpClient';
export default class Users {
    client;
    constructor() {
        this.client = new BasicClient();
    }


    getDocumentTypesList(){
      return this.client.exec('/v2/uploaddocuments/companyTypeDocuments', 'GET');
    }
    // getDocumentTypeMetadata(){
    //   return this.client.exec('/v2/uploadfiles', 'GET');
    // }
    sendDocsToTemplate(id, json){
      let body = {
        id_type_document: id,
        template: json
      }
      return this.client.exec('/v2/uploaddocuments/dataUploadDocument','POST', body);
    }
    sendNewDocsToTemplate(id, json, filesArray) {
    
      let body = {
          idabsence: id,
          template: json,
          file: filesArray,
      }
  
      return this.client.exec2('/v2/uploaddocuments/uploadFileForAbsence', body);
  }
    async sendDocsToS3(id, name, file){
      await delete file["UrlOnLoad"];
      // await delete file["UrlOnLoad"];
      // await delete file["pdfTotalPages"];
      // await delete file["pdfPage"];
      // var formData = new FormData();
      // formData.append("file", file);
      // console.log(file)
      let body = {
        id: id,
        name: name,
        file: file,
      }
      // console.log(body)
      return this.client.exec('/v2/uploaddocuments/uploadS3', 'POST', body, true)
    }
    changeLoadStatus(id){
      let body = {
        id: id,
      }
      return this.client.exec('/v2/uploaddocuments/changeState', 'PUT', body)
    }
}